enum TaskType {
    Task = 1,
    Goal = 2,
    Subtask = 3,
}

export default TaskType;
